module.exports = ".replay-table-td-pb-10 {\n  padding-bottom: 10px; }\n\n.replay-table-td-pl-10 {\n  padding-left: 10px; }\n\n.inline {\n  display: inline-block;\n  vertical-align: middle;\n  width: 230px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/replay/replay.component.scss
// module id = ./src/app/modules/sessions/replay/replay.component.scss
// module chunks = main